<mat-icon class="icon">notifications_active</mat-icon>

<h2 mat-dialog-title class="title">
  {{ "user.push_permission_title" | transloco }}
</h2>

<mat-dialog-content class="content">
  <p>{{ "user.push_permission_description" | transloco }}</p>
  <p class="hint">{{ "user.push_permission_hint" | transloco }}</p>
</mat-dialog-content>

<mat-dialog-actions class="actions" align="end">
  <button matButton="filled" class="btn-secondary" [mat-dialog-close]="false">
    {{ "user.push_permission_dismiss" | transloco }}
  </button>
  <button matButton="filled" class="btn-primary" [mat-dialog-close]="true">
    {{ "user.push_permission_enable" | transloco }}
  </button>
</mat-dialog-actions>
